import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { GlobalToken } from 'antd';

import IconGreenLeaf from '@/assets/icon-green-leaf.svg?react';

const Co2Saving = observer(({ savingValue }: { savingValue: string }) => {
  const { t } = useTranslation();
  return (
    <Co2SavingContainer>
      <IconGreenLeaf />
      <div className="co2-saving-container">
        <span className="co2-saving-value">
          {+savingValue ? Math.floor(+savingValue) : savingValue}
          &nbsp;
          {t('MT')}
        </span>
        <span className="co2-saving-unit">&nbsp;{t('GHG')}</span>
      </div>
    </Co2SavingContainer>
  );
});

const Co2SavingContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;

  .co2-saving-container {
    display: flex;
    align-items: baseline;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .co2-saving-value {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .co2-saving-unit {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }
`;

export default Co2Saving;
